const landing_page = {
  aboutUs: "Chi siamo", // translated
  topPackages: "I migliori pacchetti", // translated
  featuredHotels: "Hotel in primo piano", // translated
  topTours: "I migliori tour", // translated
  whatOurMembersSay: "Cosa dicono i nostri membri...", // translated
  followUsOnInstagram: "Seguici su Instagram", // translated
  pleaseWait: "Attendere prego...", // translated
  packages: "Pacchetti", // translated
  trustedCarHirePartners: "Partner di noleggio auto di fiducia", // translated
  ourPartners: "I nostri partner", // translated
  learnMore: "Saperne di più", // translated
};


export default landing_page;
